import { memo, useState } from "react";

// Helpers
import { useTranslate } from "helpers";

// UI
import { Button } from "ui/components/Button/Button";
import { TextField } from "ui/components/TextField/TextField";
import { NumberField } from "ui/components/TextField/NumberField";

import { ContractSaleEditCardProps } from "./types";
import { useHandleNumberFieldChange, useHandleTextFieldChange } from "services/forms/hooks";
import { Errors } from "services/forms/validation/types";
import { CONTRACT_SALE_EDIT_FORM_SCHEMA } from "./validation";
import { validateYup } from "services/forms/validation/validation";
import { useDispatch } from "react-redux";
import { updateSettings } from "services/api/settings/redux";



const ContractSaleEditCard: React.FC<ContractSaleEditCardProps> = (props) => {
    const { setting, setSetting, onSuccess, onClose } = props;

    const { t } = useTranslate();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [errors, setErrors] = useState<Errors>({});


    const handleFormSubmit = async (e: any) => {
        e.preventDefault();

        const isValid = validateYup(
            setting,
            CONTRACT_SALE_EDIT_FORM_SCHEMA,
            setErrors
        );

        if (!isValid) {
            return;
        }

        setIsLoading(true);

        try {
            if (setting.id) {
                const result = await dispatch(updateSettings(setting) as any);
                if (result?.ok && onSuccess) onSuccess();
            }

        } catch (e) {
            setIsLoading(false);
            return;
        }

        setIsLoading(false);
    };

    const handleTextFieldChange = useHandleTextFieldChange(
        setSetting,
        setting
    );

    const handleNumberFieldChange = useHandleNumberFieldChange(
        setSetting,
        setting
    );

    return (
        <>
            <div className="flex gap-4">
                <div className="w-full m-auto">
                    <div className="flex gap-3 h-full">
                        <form noValidate className="text-left flex-1 " onSubmit={handleFormSubmit}>
                            <div className="p-4">
                                <div className="mb-3">
                                    <TextField
                                        type="text"
                                        name="contractSaleFormatNumber"
                                        label={t("admin.setting.document.contract.sale.edit.contractnumber")}
                                        placeholder={t("admin.setting.document.contract.sale.edit.contractnumber")}
                                        onChange={handleTextFieldChange}
                                        value={setting.contractSaleFormatNumber}
                                        error={errors.contractSaleFormatNumber}
                                        forceShowError
                                        required

                                    ></TextField>
                                </div>
                                <div>
                                    <ul className="common-list text-sm">
                                        <li>{t("admin.setting.document.contract.sale.number.token.yyyy")}</li>
                                        <li>{t("admin.setting.document.contract.sale.number.token.yy")}</li>
                                        <li>{t("admin.setting.document.contract.sale.number.token.mm")}</li>
                                        <li>{t("admin.setting.document.contract.sale.number.token.dd")}</li>
                                        <li>{t("admin.setting.document.contract.sale.number.token.id")}</li>
                                    </ul>
                                </div>
                                <div className="flex gap-3 mt-3">
                                    <div className="flex-1">
                                        <NumberField
                                            name="contractSaleDeliveryTime"
                                            label={t("admin.setting.document.contract.sale.deliverytime")}
                                            placeholder={t("admin.setting.document.contract.sale.deliverytime.placeholder")}
                                            onChange={handleNumberFieldChange}
                                            value={setting.contractSaleDeliveryTime}
                                            error={errors.contractSaleDeliveryTime}
                                            decimals={0}
                                            min={1}
                                            step={1}
                                            groupAppend="dana"
                                        />
                                    </div>
                                    <div className="flex-1">
                                        <TextField
                                            type="text"
                                            name="contractSalePlaceOfVehicleDelivery"
                                            label={t("admin.setting.document.contract.sale.placeofvehicledelivery")}
                                            placeholder={t("admin.setting.document.contract.sale.placeofvehicledelivery.placeholder")}
                                            onChange={handleTextFieldChange}
                                            value={setting.contractSalePlaceOfVehicleDelivery}
                                            error={errors.contractSalePlaceOfVehicleDelivery}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="px-4 py-3 fixed left-0 bottom-0 bg-slate-50 border border-t-slate-200 w-full flex justify-end gap-3">
                                <Button
                                    variant="outlined"
                                    children={t("admin.close")}
                                    onClick={() => onClose()}
                                />
                                <Button
                                    variant="primary"
                                    children={t("admin.save")}
                                    type="submit"
                                />
                            </div>

                        </form>
                    </div>
                </div>
            </div>

        </>
    );
};
export default memo(ContractSaleEditCard);